import { render, staticRenderFns } from "./Supplies.vue?vue&type=template&id=c0b0b8b2&scoped=true&"
import script from "./Supplies.vue?vue&type=script&lang=js&"
export * from "./Supplies.vue?vue&type=script&lang=js&"
import style0 from "./Supplies.vue?vue&type=style&index=0&id=c0b0b8b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b0b8b2",
  null
  
)

export default component.exports